import * as React from 'react';

import classNames from 'classnames';

import { Icon } from '@components';

import { IconArrowBack, IconBurger, IconClose2 } from '@icons';

import * as s from './BurgerButton.scss';

interface IBurgerButtonProps {
	onClick?(): void;
	isShownMenu?: boolean;
	isBackState?: boolean;
}

export const BurgerButton = (props: IBurgerButtonProps) => {
	const {
		onClick,
		isShownMenu,
		isBackState,
	} = props;
	const iconGlyph = isBackState ? IconArrowBack : (isShownMenu ? IconClose2 : IconBurger);

	return (
		<div
			className={classNames(s.burger, {
				[s.toggle]: !isBackState,
			})}
			onClick={onClick}
		>
			<Icon
				className={s.icon}
				glyph={iconGlyph}
			/>
		</div>
	);
};
